// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smartbanner-show {
    margin-top: 80px;
}

.smartbanner-show .smartbanner {
    display: block;
}

/** Default **/
.smartbanner {
    position: absolute;
    left: 0;
    top: 0;
    display: none;
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-family: 'Helvetica Neue', sans-serif;
    background: #f4f4f4;
    z-index: 9998;
    -webkit-font-smoothing: antialiased;
    overflow: hidden;
    -webkit-text-size-adjust: none;
}

.smartbanner-container {
    margin: 0 auto;
    white-space: nowrap;
}

.smartbanner-close {
    display: inline-block;
    vertical-align: middle;
    margin: 0 5px 0 5px;
    font-family: 'ArialRoundedMTBold', Arial;
    font-size: 20px;
    text-align: center;
    color: #888;
    text-decoration: none;
    border: 0;
    border-radius: 14px;
    -webkit-font-smoothing: subpixel-antialiased;
}

.smartbanner-close:active,
.smartbanner-close:hover {
    color: #aaa;
}

.smartbanner-icon {
    display: inline-block;
    vertical-align: middle;
    width: 57px;
    height: 57px;
    margin-right: 12px;
    background-size: cover;
    border-radius: 10px;
}

.smartbanner-info {
    display: inline-block;
    vertical-align: middle;
    width: 44%;
    font-size: 11px;
    line-height: 1.2em;
    font-weight: bold;
}

.smartbanner-title {
    font-size: 14px;
    line-height: 18px;
}

.smartbanner-button {
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    font-weight: bold;
    color: #6a6a6a;
    background-color: #502579;
    text-transform: uppercase;
    text-decoration: none;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
}

.smartbanner-button:active,
.smartbanner-button:hover {
    color: #aaa;
}

.smartbanner-button-text {
}

.smartbanner-button-text:active,
.smartbanner-button-text:hover {
}

/** iOS **/
.smartbanner-ios {
    background: #f4f4f4;
    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    line-height: 80px;
}

.smartbanner-ios .smartbanner-close {
    border: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #888;
    text-shadow: 0 1px 0 white;
}

.smartbanner-ios .smartbanner-close:active,
.smartbanner-ios .smartbanner-close:hover {
    color: #aaa;
}

.smartbanner-ios .smartbanner-icon {
    background: rgba(0, 0, 0, 0.6);
    background-size: cover;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.smartbanner-ios .smartbanner-info {
    color: #6a6a6a;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
}

.smartbanner-ios .smartbanner-title {
    color: #4d4d4d;
    font-weight: bold;
}

.smartbanner-ios .smartbanner-button {
    padding: 0 10px;
    min-width: 10%;
    color: #6a6a6a;
    background: #efefef;
    background: linear-gradient(to bottom, #efefef, #dcdcdc);
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;
}

.smartbanner-ios .smartbanner-button:active,
.smartbanner-ios .smartbanner-button:hover {
    background: #dcdcdc;
    background: linear-gradient(to bottom, #dcdcdc, #efefef);
}

.smartbanner-ios .smartbanner-button-text {
}

.smartbanner-ios .smartbanner-button-text:active,
.smartbanner-ios .smartbanner-button-text:hover {
}

/** Android **/
.smartbanner-android {
    background: #f4f4f4;
    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    line-height: 80px;
}

.smartbanner-android .smartbanner-close {
    border: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #888;
    text-shadow: 0 1px 0 white;
}

.smartbanner-android .smartbanner-close:active,
.smartbanner-android .smartbanner-close:hover {
    color: #aaa;
}

.smartbanner-android .smartbanner-icon {
    background: rgba(0, 0, 0, 0.6);
    background-size: cover;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.smartbanner-android .smartbanner-info {
    color: #6a6a6a;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
}

.smartbanner-android .smartbanner-title {
    color: #4d4d4d;
    font-weight: bold;
}

.smartbanner-android .smartbanner-button {
    padding: 0 10px;
    min-width: 10%;
    color: #6a6a6a;
    background: #efefef;
    background: linear-gradient(to bottom, #efefef, #dcdcdc);
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;

}

.smartbanner-android .smartbanner-button:active,
.smartbanner-android .smartbanner-button:hover {
    background: #dcdcdc;
    background: linear-gradient(to bottom, #dcdcdc, #efefef);
}

.smartbanner-android .smartbanner-button-text {
}

.smartbanner-android .smartbanner-button-text:active,
.smartbanner-android .smartbanner-button-text:hover {
    background: #2ac7e1;
}

/** Windows **/
.smartbanner-windows {
    background: #f4f4f4;
    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    line-height: 80px;
}

.smartbanner-windows .smartbanner-close {
    border: 0;
    width: 18px;
    height: 18px;
    line-height: 18px;
    color: #888;
    text-shadow: 0 1px 0 white;
}

.smartbanner-windows .smartbanner-close:active,
.smartbanner-windows .smartbanner-close:hover {
}

.smartbanner-windows .smartbanner-icon {
    background: rgba(0, 0, 0, 0.6);
    background-size: cover;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.smartbanner-windows .smartbanner-info {
    color: #6a6a6a;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
}

.smartbanner-windows .smartbanner-title {
    color: #4d4d4d;
    font-weight: bold;
}

.smartbanner-windows .smartbanner-button {
    padding: 0 10px;
    min-width: 10%;
    color: #6a6a6a;
    background: #efefef;
    background: linear-gradient(to bottom, #efefef, #dcdcdc);
    border-radius: 3px;
    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;
}

.smartbanner-windows .smartbanner-button:active,
.smartbanner-windows .smartbanner-button:hover {
    background: #dcdcdc;
    background: linear-gradient(to bottom, #dcdcdc, #efefef);
}

.smartbanner-windows .smartbanner-button-text {
}

.smartbanner-windows .smartbanner-button-text:active,
.smartbanner-windows .smartbanner-button-text:hover {
}
`, "",{"version":3,"sources":["webpack://./src/kajakiraly-app/assets/smart-app-banner.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;;IAEI,WAAW;AACf;;AAEA;AACA;;AAEA;;AAEA;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,wDAAwD;IACxD,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,wDAAwD;IACxD,kBAAkB;IAClB,6GAA6G;AACjH;;AAEA;;IAEI,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;AACA;;AAEA;;AAEA;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,wDAAwD;IACxD,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,wDAAwD;IACxD,kBAAkB;IAClB,6GAA6G;;AAEjH;;AAEA;;IAEI,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;AACA;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,wDAAwD;IACxD,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;AAEA;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,wDAAwD;IACxD,kBAAkB;IAClB,6GAA6G;AACjH;;AAEA;;IAEI,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;AACA;;AAEA;;AAEA","sourcesContent":[".smartbanner-show {\n    margin-top: 80px;\n}\n\n.smartbanner-show .smartbanner {\n    display: block;\n}\n\n/** Default **/\n.smartbanner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: none;\n    width: 100%;\n    height: 80px;\n    line-height: 80px;\n    font-family: 'Helvetica Neue', sans-serif;\n    background: #f4f4f4;\n    z-index: 9998;\n    -webkit-font-smoothing: antialiased;\n    overflow: hidden;\n    -webkit-text-size-adjust: none;\n}\n\n.smartbanner-container {\n    margin: 0 auto;\n    white-space: nowrap;\n}\n\n.smartbanner-close {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 5px 0 5px;\n    font-family: 'ArialRoundedMTBold', Arial;\n    font-size: 20px;\n    text-align: center;\n    color: #888;\n    text-decoration: none;\n    border: 0;\n    border-radius: 14px;\n    -webkit-font-smoothing: subpixel-antialiased;\n}\n\n.smartbanner-close:active,\n.smartbanner-close:hover {\n    color: #aaa;\n}\n\n.smartbanner-icon {\n    display: inline-block;\n    vertical-align: middle;\n    width: 57px;\n    height: 57px;\n    margin-right: 12px;\n    background-size: cover;\n    border-radius: 10px;\n}\n\n.smartbanner-info {\n    display: inline-block;\n    vertical-align: middle;\n    width: 44%;\n    font-size: 11px;\n    line-height: 1.2em;\n    font-weight: bold;\n}\n\n.smartbanner-title {\n    font-size: 14px;\n    line-height: 18px;\n}\n\n.smartbanner-button {\n    position: absolute;\n    right: 20px;\n    top: 0;\n    bottom: 0;\n    margin: auto 0;\n    height: 24px;\n    font-size: 14px;\n    line-height: 24px;\n    text-align: center;\n    font-weight: bold;\n    color: #6a6a6a;\n    background-color: #502579;\n    text-transform: uppercase;\n    text-decoration: none;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.smartbanner-button:active,\n.smartbanner-button:hover {\n    color: #aaa;\n}\n\n.smartbanner-button-text {\n}\n\n.smartbanner-button-text:active,\n.smartbanner-button-text:hover {\n}\n\n/** iOS **/\n.smartbanner-ios {\n    background: #f4f4f4;\n    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n    line-height: 80px;\n}\n\n.smartbanner-ios .smartbanner-close {\n    border: 0;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    color: #888;\n    text-shadow: 0 1px 0 white;\n}\n\n.smartbanner-ios .smartbanner-close:active,\n.smartbanner-ios .smartbanner-close:hover {\n    color: #aaa;\n}\n\n.smartbanner-ios .smartbanner-icon {\n    background: rgba(0, 0, 0, 0.6);\n    background-size: cover;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.smartbanner-ios .smartbanner-info {\n    color: #6a6a6a;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.smartbanner-ios .smartbanner-title {\n    color: #4d4d4d;\n    font-weight: bold;\n}\n\n.smartbanner-ios .smartbanner-button {\n    padding: 0 10px;\n    min-width: 10%;\n    color: #6a6a6a;\n    background: #efefef;\n    background: linear-gradient(to bottom, #efefef, #dcdcdc);\n    border-radius: 3px;\n    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;\n}\n\n.smartbanner-ios .smartbanner-button:active,\n.smartbanner-ios .smartbanner-button:hover {\n    background: #dcdcdc;\n    background: linear-gradient(to bottom, #dcdcdc, #efefef);\n}\n\n.smartbanner-ios .smartbanner-button-text {\n}\n\n.smartbanner-ios .smartbanner-button-text:active,\n.smartbanner-ios .smartbanner-button-text:hover {\n}\n\n/** Android **/\n.smartbanner-android {\n    background: #f4f4f4;\n    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n    line-height: 80px;\n}\n\n.smartbanner-android .smartbanner-close {\n    border: 0;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    color: #888;\n    text-shadow: 0 1px 0 white;\n}\n\n.smartbanner-android .smartbanner-close:active,\n.smartbanner-android .smartbanner-close:hover {\n    color: #aaa;\n}\n\n.smartbanner-android .smartbanner-icon {\n    background: rgba(0, 0, 0, 0.6);\n    background-size: cover;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.smartbanner-android .smartbanner-info {\n    color: #6a6a6a;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.smartbanner-android .smartbanner-title {\n    color: #4d4d4d;\n    font-weight: bold;\n}\n\n.smartbanner-android .smartbanner-button {\n    padding: 0 10px;\n    min-width: 10%;\n    color: #6a6a6a;\n    background: #efefef;\n    background: linear-gradient(to bottom, #efefef, #dcdcdc);\n    border-radius: 3px;\n    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;\n\n}\n\n.smartbanner-android .smartbanner-button:active,\n.smartbanner-android .smartbanner-button:hover {\n    background: #dcdcdc;\n    background: linear-gradient(to bottom, #dcdcdc, #efefef);\n}\n\n.smartbanner-android .smartbanner-button-text {\n}\n\n.smartbanner-android .smartbanner-button-text:active,\n.smartbanner-android .smartbanner-button-text:hover {\n    background: #2ac7e1;\n}\n\n/** Windows **/\n.smartbanner-windows {\n    background: #f4f4f4;\n    background: linear-gradient(to bottom, #f4f4f4, #cdcdcd);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n    line-height: 80px;\n}\n\n.smartbanner-windows .smartbanner-close {\n    border: 0;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    color: #888;\n    text-shadow: 0 1px 0 white;\n}\n\n.smartbanner-windows .smartbanner-close:active,\n.smartbanner-windows .smartbanner-close:hover {\n}\n\n.smartbanner-windows .smartbanner-icon {\n    background: rgba(0, 0, 0, 0.6);\n    background-size: cover;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.smartbanner-windows .smartbanner-info {\n    color: #6a6a6a;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.smartbanner-windows .smartbanner-title {\n    color: #4d4d4d;\n    font-weight: bold;\n}\n\n.smartbanner-windows .smartbanner-button {\n    padding: 0 10px;\n    min-width: 10%;\n    color: #6a6a6a;\n    background: #efefef;\n    background: linear-gradient(to bottom, #efefef, #dcdcdc);\n    border-radius: 3px;\n    box-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, 0.6), 0 2px 0 rgba(255, 255, 255, 0.7) inset;\n}\n\n.smartbanner-windows .smartbanner-button:active,\n.smartbanner-windows .smartbanner-button:hover {\n    background: #dcdcdc;\n    background: linear-gradient(to bottom, #dcdcdc, #efefef);\n}\n\n.smartbanner-windows .smartbanner-button-text {\n}\n\n.smartbanner-windows .smartbanner-button-text:active,\n.smartbanner-windows .smartbanner-button-text:hover {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
